import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const STATUS_COLORS = {
  pending: 'var(--warning)',
  packed: 'var(--info)',
  shipped: 'var(--primary)',
};

const OrderStatusChart = ({ statistics, isRtl, height = 260 }) => {
  const labels = {
    pending: isRtl ? 'معلق' : 'Pending',
    packed: isRtl ? 'تم التعبئة' : 'Packed',
    shipped: isRtl ? 'تم الشحن' : 'Shipped',
  };

  const data = [
    { status: 'pending', count: statistics?.pendingOrders || 0, label: labels.pending, fill: STATUS_COLORS.pending },
    { status: 'packed', count: statistics?.packedOrders || 0, label: labels.packed, fill: STATUS_COLORS.packed },
    { status: 'shipped', count: statistics?.shippedOrders || 0, label: labels.shipped, fill: STATUS_COLORS.shipped },
  ];

  const hasData = data.some((d) => d.count > 0);

  if (!hasData) {
    return (
      <div className="chart-empty" style={{ height }}>
        <p>{isRtl ? 'لا توجد طلبات بعد' : 'No orders yet'}</p>
      </div>
    );
  }

  return (
    <div className="order-status-chart-container" style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 8, right: 24, left: 0, bottom: 8 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 12, fill: 'var(--text-muted)' }} stroke="var(--border)" />
          <YAxis
            type="category"
            dataKey="label"
            width={isRtl ? 90 : 90}
            tick={{ fontSize: 12, fill: 'var(--text)' }}
            stroke="var(--border)"
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--r-md)',
              boxShadow: 'var(--shadow-md)',
            }}
            formatter={(value) => [value, isRtl ? 'العدد' : 'Count']}
            labelFormatter={(label) => label}
          />
          <Bar dataKey="count" radius={[0, 4, 4, 0]} name={isRtl ? 'الطلبات' : 'Orders'}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OrderStatusChart;
